export { ReactComponent as WordObject } from './svgs/word-object.svg';
